import emit from '../../common/events';
import { OffCanvasConfig } from './interfaces/off-canvas.interface';

export class OffCanvasAnalytics {
  /**
   * Dispatches the analytics event whenever the off-canvas is opened.
   *
   * @param element
   * @param offCanvas
   */
  openEvent(element: Element, offCanvas: OffCanvasConfig): void {
    emit({
      element,
      name: 'click',
      detail: {
        eventName: 'mhecomm-off-canvas-open',
        offCanvasId: offCanvas.id,
        label: 'Off-canvas Open',
        comp: 'off-canvas',
      },
    });
  }

  /**
   * Dispatches the analytics event whenever the off-canvas is closed.
   *
   * @param element
   * @param offCanvas
   */
  closeEvent(element: Element, offCanvas: OffCanvasConfig): void {
    emit({
      element,
      name: 'click',
      detail: {
        eventName: 'mhecomm-off-canvas-close',
        offCanvasId: offCanvas.id,
        label: 'Off-canvas Close',
        comp: 'off-canvas',
      },
    });
  }
}